// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\nsection[data-v-bf095620] {\n  display: flex;\n  flex-direction: column;\n  gap: 2.5rem;\n  padding-bottom: 5rem;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
